import gsap from 'gsap';

const initOpenSearch = () => {
  const buttonOpen = document.querySelector('[data-button-open-search]');
  const buttonClose = document.querySelector('[data-button-close-search]');
  const container = document.querySelector('[data-container-search]');
  const mainNav = document.querySelector('[data-main-nav]');
  const groupLeft = document.querySelector('[data-group-left]');
  const wrapper = document.querySelector('[data-header-wrapper]');

  if (!buttonOpen || !buttonClose || !container || !mainNav || !groupLeft || !wrapper) {
    return;
  }

  let isOpen = false;

  gsap.set(container, {
    width: 0,
    opacity: 0,
    display: 'none',
    overflow: 'hidden',
  });

  buttonOpen.addEventListener('click', () => {
    buttonOpen.classList.toggle('is-clicked');
    mainNav.classList.toggle('is-disabled');

    isOpen = !isOpen;

    if (isOpen) {
      if (window.innerWidth < 848) {
        wrapper.classList.toggle('is-revers');
        groupLeft.classList.toggle('is-hidden');
      }

      gsap.set(container, {display: 'flex'});

      gsap.to(container, {
        width: 'auto',
        opacity: 1,
        duration: 0.4,
        ease: 'linear',
      });
    } else {
      gsap.to(container, {
        width: 0,
        opacity: 0,
        duration: 0.4,
        ease: 'linear',
        onComplete: () => {
          gsap.set(container, {display: 'none'});

          if (window.innerWidth < 848) {
            wrapper.classList.toggle('is-revers');
            groupLeft.classList.toggle('is-hidden');
          }
        },
      });
    }
  });

  buttonClose.addEventListener('click', () => {
    isOpen = !isOpen;

    buttonOpen.classList.toggle('is-clicked');
    mainNav.classList.toggle('is-disabled');

    gsap.to(container, {
      width: 0,
      opacity: 0,
      duration: 0.4,
      ease: 'linear',
      onComplete: () => {
        gsap.set(container, {display: 'none'});

        if (window.innerWidth < 848) {
          wrapper.classList.toggle('is-revers');
          groupLeft.classList.toggle('is-hidden');
        }
      },
    });
  });
};

export {initOpenSearch};
